import React from 'react'
import { useNavigate } from 'react-router-dom';
import './SucessMsgQb.css'

export default function SucessMsgQb({details}) {
    const navigate = useNavigate();
    return (
        <div className='Conteiner_sucessMsg_QB'>
            <div className='subConteiner_sucessMsg_QB p-4'>
                <div className='d-flex justify-content-center'>
                    <img src='/ContentM_images/SucessMsgQb.svg' alt='sucess logo'></img>
                </div>
                <div className='d-flex justify-content-center mt-3'>
                    <span className=" my-4 successfully_message">
                    You have successfully saved the {details.name}!
                    </span>
                </div>
                <div className='d-flex justify-content-center mt-3'>
                    <button className='sucess_okayBtn_Qb' onClick={()=>{navigate("/questionLibrary")}}>Okay</button>
                </div>
            </div>
        </div>
    )
}
